
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"101","height":"101","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","stroke":"#AFB0BF","stroke-width":"8.333","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M38 92.288a4.167 4.167 0 100-8.333 4.167 4.167 0 000 8.333zM83.833 92.288a4.167 4.167 0 100-8.333 4.167 4.167 0 000 8.333zM4.666 4.787h16.667L32.499 60.58a8.334 8.334 0 008.334 6.708h40.5a8.333 8.333 0 008.333-6.708l6.667-34.959H25.499"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .621)","d":"M0 0h100v100H0z"}})])])])
          )
        }
      }
    